import EmarPatientDispenseReportV1 from "../../../../components/form_builder/elements/emar_patient_dispense_report/EmarPatientDispenseReportV1.vue";

export default {
  componentName: "fb-emar-patient-dispense-report-v1",
  component: EmarPatientDispenseReportV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Emar Patient Dispense Report",
      description: "",
      eFormEditable: false,
      hidden: false,
      dateFilter: "currentday",
      dependentProperties: {}
    },
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value,
  },
  validate: () => {
    return [];
  },
};
